"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfSectionPropertiesExporter = void 0;
var tslib_1 = require("tslib");
var section_properties_1 = require("../../../core/model/section/section-properties");
var rtf_export_sr_1 = require("../../translation-table/rtf-export-sr");
var rtf_content_exporter_1 = require("./rtf-content-exporter");
var rtf_properties_exporter_1 = require("./rtf-properties-exporter");
var line_numbering_properties_1 = require("../../../core/model/section/line-numbering-properties");
var enums_1 = require("../../../core/model/section/enums");
var RtfSectionPropertiesExporter = (function (_super) {
    tslib_1.__extends(RtfSectionPropertiesExporter, _super);
    function RtfSectionPropertiesExporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RtfSectionPropertiesExporter.prototype.exportSectionProperties = function (section) {
        this.exportSectionMargins(section.sectionProperties.margins);
        this.exportSectionOffsets(section.sectionProperties);
        this.exportSectionPage(section.sectionProperties);
        this.exportSectionGeneralSettings(section.sectionProperties);
        this.exportSectionColumns(section.sectionProperties);
        this.exportSectionPageNumbering(section.sectionProperties);
        this.exportSectionLineNumbering(section.sectionProperties.lineNumbering);
    };
    RtfSectionPropertiesExporter.prototype.exportSectionPageNumbering = function (properties) {
        if (!properties.continueNumbering) {
            this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionPageNumberingStart, properties.firstPageNumber);
            this.rtfBuilder.writeCommand(rtf_export_sr_1.RtfExportSR.SectionPageNumberingRestart);
        }
    };
    RtfSectionPropertiesExporter.prototype.exportSectionMargins = function (margins) {
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionMarginsLeft, margins.left);
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionMarginsRight, margins.right);
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionMarginsTop, margins.top);
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionMarginsBottom, margins.bottom);
    };
    RtfSectionPropertiesExporter.prototype.exportSectionOffsets = function (properties) {
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionMarginsHeaderOffset, properties.headerOffset);
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionMarginsFooterOffset, properties.footerOffset);
    };
    RtfSectionPropertiesExporter.prototype.exportSectionPage = function (properties) {
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionPageWidth, properties.pageWidth);
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionPageHeight, properties.pageHeight);
        if (properties.landscape)
            this.rtfBuilder.writeCommand(rtf_export_sr_1.RtfExportSR.SectionPageLandscape);
    };
    RtfSectionPropertiesExporter.prototype.exportSectionGeneralSettings = function (properties) {
        var defaultProperties = new section_properties_1.SectionProperties();
        if (properties.startType != defaultProperties.startType)
            this.writeEnumValueCommand(rtf_content_exporter_1.RtfContentExporter.sectionStartTypes, properties.startType, rtf_export_sr_1.RtfExportSR.SectionBreakTypeNextPage);
        if (properties.differentFirstPage != defaultProperties.differentFirstPage)
            this.rtfBuilder.writeCommand(rtf_export_sr_1.RtfExportSR.SectionTitlePage);
    };
    RtfSectionPropertiesExporter.prototype.exportSectionColumns = function (properties) {
        if (properties.equalWidthColumns) {
            this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionColumnsCount, properties.columnCount);
            this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionSpaceBetweenColumns, properties.space);
        }
        else
            this.exportSectionColumnsDetails(properties.columnsInfo);
    };
    RtfSectionPropertiesExporter.prototype.exportSectionColumnsDetails = function (columns) {
        var count = columns.length;
        if (count > 0)
            this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionColumnsCount, count);
        for (var i = 0; i < count; i++)
            this.exportSectionColumn(columns[i], i);
    };
    RtfSectionPropertiesExporter.prototype.exportSectionColumn = function (column, columnIndex) {
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionColumnNumber, columnIndex + 1);
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionColumnWidth, column.width);
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionColumnSpace, column.space);
    };
    RtfSectionPropertiesExporter.prototype.writeEnumValueCommand = function (table, value, defaultCommand) {
        var command = table[value];
        if (!command)
            command = defaultCommand;
        this.rtfBuilder.writeCommand(command);
    };
    RtfSectionPropertiesExporter.prototype.exportSectionLineNumbering = function (lineNumbering) {
        if (!lineNumbering || !lineNumbering.isDefined)
            return;
        this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionLineNumberingCountBy, lineNumbering.countBy);
        if (lineNumbering.distance !== line_numbering_properties_1.LineNumberDefaults.distance)
            this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionLineNumberingDistance, lineNumbering.distance);
        if (lineNumbering.start !== line_numbering_properties_1.LineNumberDefaults.start)
            this.rtfBuilder.writeIntegerCommand(rtf_export_sr_1.RtfExportSR.SectionLineNumberingStart, lineNumbering.start);
        if (lineNumbering.restart !== line_numbering_properties_1.LineNumberDefaults.restart)
            this.exportLineNumberRestartType(lineNumbering.restart);
    };
    RtfSectionPropertiesExporter.prototype.exportLineNumberRestartType = function (restart) {
        switch (restart) {
            case enums_1.LineNumberingRestartType.NewPage:
                this.rtfBuilder.writeCommand(rtf_export_sr_1.RtfExportSR.SectionLineNumberingRestartNewPage);
                break;
            case enums_1.LineNumberingRestartType.NewSection:
                this.rtfBuilder.writeCommand(rtf_export_sr_1.RtfExportSR.SectionLineNumberingRestartNewSection);
                break;
            case enums_1.LineNumberingRestartType.Continuous:
                this.rtfBuilder.writeCommand(rtf_export_sr_1.RtfExportSR.SectionLineNumberingContinuous);
                break;
        }
    };
    return RtfSectionPropertiesExporter;
}(rtf_properties_exporter_1.RtfPropertiesExporter));
exports.RtfSectionPropertiesExporter = RtfSectionPropertiesExporter;
